export const CONTROLLED_ALLERGENS = [
  'Wheat',
  'Gluten',
  'Milk',
  'Egg',
  'Soy',
  'Peanut',
  'Sesame',
  'Lupin',
  'Fish',
  'Crustacean',
  'Mollusc',
  'Almond',
  'Brazil nut',
  'Cashew',
  'Hazelnut',
  'Macadamia',
  'Pecan',
  'Pine nut',
  'Pistachio',
  'Walnut',
  'Barley',
  'Oats',
  'Rye',
  'Sulphites',
] as const

export type ControlledAllergen = typeof CONTROLLED_ALLERGENS[number]

const CONTROLLED_ALLERGEN_SET = new Set<string>(CONTROLLED_ALLERGENS)

export function isControlledAllergen(value: unknown): value is ControlledAllergen {
  return typeof value === 'string' && CONTROLLED_ALLERGEN_SET.has(value)
}

export function normalizeControlledAllergens(value: unknown): ControlledAllergen[] | null {
  if (!Array.isArray(value)) return null
  const result: ControlledAllergen[] = []
  for (const item of value) {
    if (!isControlledAllergen(item)) return null
    if (!result.includes(item)) result.push(item)
  }
  return result
}

export function unrecognisedAllergens(values: readonly string[]) {
  return values.filter((value) => !isControlledAllergen(value))
}
